/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchShiftChangeProposalsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {SearchShiftChangeProposalsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const searchShiftChangeProposals = (request: SearchShiftChangeProposalsRequest, options?: CashRequestOptions) => post<SearchShiftChangeProposalsRequest, SearchShiftChangeProposalsResponse>("/2.0/cash/search-shift-change-proposals", request, {...options, rejectOnError: true })